import ProfileService from "Services/profile";
import {
  loadNotixProfile,
  triggerActualProfileData,
} from "../reducers/notixProfileSlice";
import {toast} from "react-toastify";
import I18n from "../Services/i18n";

export const LOAD_PROFILE_REQUESTED = "LOAD_PROFILE_REQUESTED";
export const LOAD_PROFILE_OK = "LOAD_PROFILE_OK";
export const LOAD_PROFILE_FAIL = "LOAD_PROFILE_FAIL";

export const UPDATE_PROFILE_REQUESTED = "UPDATE_PROFILE_REQUESTED";
export const UPDATE_PROFILE_OK = "UPDATE_PROFILE_OK";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";

export const SET_ACCOUNT_TYPE = "SET_ACCOUNT_TYPE";
export const SET_PROFILE = "SET_PROFILE";

export const SET_CURRENT_PASSWORD = "SET_CURRENT_PASSWORD";
export const SET_NEW_PASSWORD = "SET_NEW_PASSWORD";
export const SET_NEW_CONFIRM_PASSWORD = "SET_NEW_CONFIRM_PASSWORD";

export const UPDATE_PASSWORD_REQUESTED = "UPDATE_PASSWORD_REQUESTED";
export const UPDATE_PASSWORD_OK = "UPDATE_PASSWORD_OK";
export const UPDATE_PASSWORD_FAIL = "UPDATE_PASSWORD_FAIL";

export function get() {
  return (dispatch) => {
    dispatch({ type: LOAD_PROFILE_REQUESTED });

    ProfileService.get()
      .then((data) => {
        dispatch({
          type: LOAD_PROFILE_OK,
          data,
        });
      })
      .catch((errors) => {
        dispatch({
          type: LOAD_PROFILE_FAIL,
          errors,
        });
      });
  };
}

export function update(user, isAcceptOurTerms = false) {
  return (dispatch) => {
    dispatch({ type: UPDATE_PROFILE_REQUESTED });

    ProfileService.update(user, isAcceptOurTerms)
      .then((data) => {
        dispatch({
          type: UPDATE_PROFILE_OK,
          data,
        });
      })
      .then(() => {
        return dispatch(triggerActualProfileData());
      })
      .then(() => {
        dispatch(loadNotixProfile());
      })
      .catch((errors) => {
        dispatch({
          type: UPDATE_PROFILE_FAIL,
          errors,
        });
        toast.error(I18n.getStringByKey("toast_failed-profile-update"));
      });
  };
}

export function set(data) {
  return {
    type: SET_PROFILE,
    data,
  };
}

export function setAccountType(data) {
  return {
    type: SET_ACCOUNT_TYPE,
    data,
  };
}

export function setCurrentPassword(data) {
  return {
    type: SET_CURRENT_PASSWORD,
    data,
  };
}

export function setNewPassword(data) {
  return {
    type: SET_NEW_PASSWORD,
    data,
  };
}

export function setNewConfirmPassword(data) {
  return {
    type: SET_NEW_CONFIRM_PASSWORD,
    data,
  };
}

export function updatePassword(
  currentPassword,
  newPassword,
  newConfirmPassword
) {
  return (dispatch) => {
    dispatch({ type: UPDATE_PASSWORD_REQUESTED });

    ProfileService.changePassword(
      currentPassword,
      newPassword,
      newConfirmPassword
    )
      .then((data) => {
        dispatch({
          type: UPDATE_PASSWORD_OK,
          data,
        });
      })
      .catch((errors) => {
        dispatch({
          type: UPDATE_PASSWORD_FAIL,
          errors,
        });
      });
  };
}
